import React, { useState } from "react";
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import DocumentSelectorModal from "./DocumentSelectorModal";

export default function DebitNoteInfo({
  persona,
  documentoRelacionadoId,
  documentoRelacionadoNumero,
  documentoRelacionadoClaveAcceso,
  motivo,
  onDocumentSelected,
  onChange,
  mobile = false,
}) {
  const [open, setOpen] = useState(false);

  const hasDocument = Boolean(documentoRelacionadoId);

  return (
    <Box sx={{ width: "100%" }}>
      <Paper
        sx={{
          p: mobile ? 1.5 : 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          bgcolor: "#fafafa",
        }}
      >
        <Typography sx={{ fontWeight: 800, color: "#333", mb: 1 }}>
          Documento relacionado
        </Typography>

        <Button
          variant="contained"
          onClick={() => setOpen(true)}
          sx={{ bgcolor: "#1565C0", mb: 1.5 }}
          fullWidth={mobile}
        >
          Seleccionar documento
        </Button>

        {hasDocument ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <TextField
              label="Documento relacionado"
              value={documentoRelacionadoNumero || ""}
              InputProps={{ readOnly: true }}
              fullWidth={mobile}
              sx={{ minWidth: mobile ? "100%" : 350 }}
            />
            <TextField
              label="Clave de acceso"
              value={documentoRelacionadoClaveAcceso || ""}
              InputProps={{ readOnly: true }}
              fullWidth
            />
          </Box>
        ) : (
          <Typography sx={{ fontSize: 13, color: "#777" }}>
            Selecciona el documento que será sustento de la nota de débito.
          </Typography>
        )}

        <Box sx={{ mt: 2 }}>
          <TextField
            label="Motivo de la nota de débito"
            value={motivo || ""}
            onChange={(e) => onChange?.({ nota_debito_motivo: e.target.value })}
            multiline
            minRows={2}
            fullWidth
          />
        </Box>
      </Paper>

      <DocumentSelectorModal
        open={open}
        onClose={() => setOpen(false)}
        persona={persona}
        title="Seleccionar documento para nota de débito"
        tipo="FACTURA"
        endpoint="/facturas/documentos-relacionados/facturas-cliente/"
        detailEndpoint="/facturas/documentos-relacionados/detalle-factura/"
        onSelected={onDocumentSelected}
      />
    </Box>
  );
}